<template>
  <div class="contents">
    <div class="wrap">

      <!-- 검색 영역 -->
      <section>
        <h2 class="page_title --view">현금 계산서 발행 <span class="tag_exempt">면세</span></h2>
        <article>
          <ul class="search_filter">
            <li>
              <p>조회기간</p>
              <Datepicker v-model="searchInfo.startDate" :defaultDate="searchInfo.startDate" :format="'YYYY-MM-DD'" />
              <span>~</span>
              <Datepicker v-model="searchInfo.endDate" :defaultDate="searchInfo.endDate" :format="'YYYY-MM-DD'" />
            </li>
            <li>
              <p>한의원명</p>
              <input type="text" placeholder="입력하세요" class="form_control" v-model="searchInfo.clinicNm" @keyup.enter="fn_search">
            </li>
            <li>
              <p>사업자번호</p>
              <input type="text" placeholder="입력하세요" class="form_control" style="max-width:180px;" v-model="searchInfo.bizNo" @keyup.enter="fn_search">
            </li>
            <li>
              <button class="btn btn_md btn_outline" @click="fn_search">조회</button>
              <button class="btn btn_md btn_gray ml8" @click="fn_reset_search">초기화</button>
            </li>
          </ul>
        </article>
      </section>

      <section class="view">

        <!-- 상단 요약 카드 -->
        <div class="summary_area">
          <div class="summary_card" v-for="card in summaryCards" :key="card.key">
            <p class="card_label">{{ card.label }}</p>
            <strong class="card_value" :class="card.colorClass">
              {{ fn_format_card(card) }}
            </strong>
          </div>
        </div>

        <!-- 한의원 목록 테이블 -->
        <div class="table_list">
<!--          <div class="table_option">-->
<!--            <div></div>-->
<!--            <button class="btn btn_md btn_outline" @click="fn_excel_download">엑셀다운로드</button>-->
<!--          </div>-->
          <table class="list">
            <thead>
              <tr>
                <th>한의원명</th>
                <th>사업자번호</th>
                <th>무통장 입금 건수</th>
                <th>무통장 입금 총액</th>
                <th>예치금 사용 건수</th>
                <th>예치금 사용 총액</th>
                <th>발행요청 대기금액</th>
                <th>상세</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="cashInvoiceList.length === 0">
                <td colspan="9" class="ac"><span>조회된 데이터가 없습니다.</span></td>
              </tr>
              <tr v-for="(item, index) in cashInvoiceList" :key="index">
                <td><span>{{ item.clinic_nm }}</span></td>
                <td><span>{{ formatBizNumber(item.clinic_business_num) }}</span></td>
                <td class="ac"><span>{{ item.vb_cnt }}건</span></td>
                <td class="ar"><span>{{ fn_comma_won(item.vb_amt) }}</span></td>
                <td class="ac"><span>{{ item.deposit_cnt }}건</span></td>
                <td class="ar"><span>{{ fn_comma_won(item.deposit_amt) }}</span></td>
                <td class="ar"><span>{{ fn_comma_won(item.wait_amt) }}</span></td>
                <td>
                  <button class="btn btn_sm btn_outline" @click="fn_open_detail(item)">상세</button>
                </td>
              </tr>
            </tbody>
          </table>
          <Pagination :pageInfo="searchInfo.pageInfo" @clickPage="fn_movePage" v-show="pagingShow" />
        </div>
      </section>
    </div>

    <!-- 요청 모달 -->
    <CashTaxInvoiceRequestModal :detailData="detailData" />

  </div>
</template>

<script>
  import axios from 'axios'
  import commonUtil from '@/mixin/commonUtil'
  import Pagination from '@/components/AdminPagination.vue'
  import Datepicker from '@/components/Datepicker.vue'
  import CashTaxInvoiceRequestModal from '@/modal/admin/cashTaxInvoiceRequestModal.vue'

  export default {
    name: 'CashInvoice',
    components: { Pagination, Datepicker, CashTaxInvoiceRequestModal: CashTaxInvoiceRequestModal },
    mixins: [commonUtil],
    data() {
      return {
        searchInfo: {
          startDate: '',
          endDate: '',
          clinicNm: '',
          bizNo: '',
          invoiceStatus: '',
          pageInfo: { page: 1, pageSize: 10, totPage: 0 }
        },
        pagingShow: false,
        cashInvoiceList: [],
        summaryInfo: {
          clinic_cnt: 0, bank_cnt: 0, deposit_cnt: 0,
          bank_total_amt: 0, deposit_total_amt: 0, total_amt: 0,
          wait_amt: 0, req_amt: 0, complete_amt: 0
        },
        summaryCards: [
          { key: 'clinic_cnt',        label: '대상 한의원 수',      unit: '개', isAmt: false, colorClass: '' },
          { key: 'bank_cnt',       label: '무통장 입금 총 건수', unit: '건', isAmt: false, colorClass: '' },
          { key: 'bank_total_amt', label: '무통장 입금 총액',    unit: '원', isAmt: true,  colorClass: '' },
          { key: 'deposit_cnt',       label: '예치금 사용 총 건수', unit: '건', isAmt: false, colorClass: '' },
          { key: 'deposit_total_amt', label: '예치금 사용 총액',    unit: '원', isAmt: true,  colorClass: '' },
          { key: 'wait_amt',          label: '발행요청 대기 금액',  unit: '원', isAmt: true,  colorClass: 'text_blue' }
        ],
        detailData: null,
        selectedClinic: null
      }
    },
    created() {
      const stored = this.$store.getters['commonStore/getSearchInfo']
      if (stored && Object.keys(stored).length > 0) {
        this.searchInfo = stored
      }
    },
    mounted() {
      const today = new Date()
      const y = today.getFullYear()
      const m = (today.getMonth() + 1).toString().padStart(2, '0')
      const d = today.getDate().toString().padStart(2, '0')
      this.searchInfo.startDate = `${y}-${m}-01`
      this.searchInfo.endDate   = `${y}-${m}-${d}`

      this.fn_search()
    },
    methods: {
      fn_search() {
        this.$store.dispatch('commonStore/setSearchInfo', this.searchInfo)

        // TODO: API 연동
        const payload = { ...this.searchInfo, bizNo: this.searchInfo.bizNo.replace(/-/g, '') }
        axios.post('/api/admin/settlement/getCashInvoiceList', payload)
          .then((res) => {

            console.log("@@@@@ res data: %o",res.data);

            this.cashInvoiceList = res.data.cashInvoiceList;
            Object.assign(this.summaryInfo, res.data.summaryInfo);
            this.searchInfo.pageInfo.totPage = res.data.totCnt;
            this.pagingShow = this.searchInfo.pageInfo.totPage > 0
          })
          .catch((err) => console.log(err))

      },
      fn_reset_search() {
        const today = new Date()
        const y = today.getFullYear()
        const m = (today.getMonth() + 1).toString().padStart(2, '0')
        const d = today.getDate().toString().padStart(2, '0')
        this.searchInfo = {
          startDate: `${y}-${m}-01`,
          endDate:   `${y}-${m}-${d}`,
          clinicNm: '', bizNo: '', invoiceStatus: '',
          pageInfo: { page: 1, pageSize: 10, totPage: 0 }
        }
        this.fn_search()
      },
      fn_movePage(page) {
        this.searchInfo.pageInfo.page = page
        this.fn_search()
      },
      fn_open_detail(item) {
        this.detailData = {
          clinic: { ...item },
          startDate: this.searchInfo.startDate,
          endDate:   this.searchInfo.endDate
        }
        this.$nextTick(() => {
          this.$bvModal.show('cashTaxInvoiceRequestModal')
        })
      },
      fn_on_request_confirm() {
        this.fn_search()
      },
      fn_excel_download() {
        // TODO: 엑셀 다운로드 API 연동
        // axios.post('/api/admin/settlement/downloadDepositInvoiceExcel', this.searchInfo, { responseType: 'blob' })
        //   .then((res) => { ... })
        //   .catch((err) => console.log(err))
        alert('엑셀 다운로드 기능은 준비 중입니다.')
      },
      fn_format_card(card) {
        const val = this.summaryInfo[card.key] || 0
        return card.isAmt
          ? `${this.fn_comma_won(val)}${card.unit}`
          : `${val.toLocaleString('ko-KR')}${card.unit}`
      },
      fn_format_dt(dt) {
        return dt ? dt.substring(0, 10) : '-'
      },
      getInvoiceBadgeClass(status) {
        return { INV00: 'badge_gray', INV01: 'badge_blue', INV02: 'badge_green', INV03: 'badge_red', INV04: 'badge_orange' }[status] || ''
      }
    }
  }
</script>

<style scoped>
  /* 면세 태그 */
  .tag_exempt {
    display: inline-block;
    font-size: 1.2rem;
    font-weight: 600;
    color: #276749;
    background: #f0fff4;
    border: 1px solid #c6f6d5;
    border-radius: 4px;
    padding: 2px 8px;
    margin-left: 8px;
    vertical-align: middle;
  }

  .summary_area {
    display: flex;
    gap: 12px;
    margin-bottom: 20px;
    flex-wrap: wrap;
  }
  .summary_card {
    flex: 1;
    min-width: 150px;
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 18px 20px;
    box-shadow: 0 1px 4px rgba(0,0,0,0.05);
  }
  .card_label { font-size: 1.3rem; color: #888; margin-bottom: 8px; }
  .card_value { font-size: 1.7rem; font-weight: 700; color: #262939; }
  .text_blue  { color: #2b6cb0; }
  .text_green { color: #276749; }

  .status_badge {
    display: inline-block;
    padding: 3px 10px;
    border-radius: 12px;
    font-size: 1.2rem;
    font-weight: 600;
    white-space: nowrap;
  }
  .badge_gray   { background: #f7fafc; color: #718096; border: 1px solid #e2e8f0; }
  .badge_blue   { background: #ebf4ff; color: #2b6cb0; }
  .badge_green  { background: #f0fff4; color: #276749; }
  .badge_red    { background: #fff5f5; color: #c53030; }
  .badge_orange { background: #fffaf0; color: #c05621; }

  .text_dash { color: #a0aec0; }
  .ml8 { margin-left: 8px; }
  .ar { text-align: right; }
  .ac { text-align: center; }
</style>